import { EDIT_PROFESSIONALS } from 'navigation/CONSTANTS'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from 'reduxStore/store'
import {
  deleteEstablishmentProfessionalRelation,
  getProfessionalListInEstablishment
} from 'services/establishment'
import { IUserSession } from 'types'

const useProfessional = () => {
  const [state, setState] = useState<IStateStdTypes>('idle')
  const [professionals, setProfessionals] = useState<IUserSession[]>([])
  const [deletionState, setDeletionState] = useState<IStateStdTypes>('idle')
  const deletionInProgress = useRef(false)

  const navigate = useNavigate()
  const establishmentId = useAppSelector(
    rState => rState.establishment.data?.establishment_id
  )

  const fetchProfessionals = async () => {
    setState('loading')

    const response = await getProfessionalListInEstablishment(
      establishmentId ?? ''
    )

    if (response.success) {
      setProfessionals(response.data ?? [])
      setState('success')
    } else {
      setProfessionals([])
      setState('error')
    }
  }

  const handleDeleteProfessional = async (
    professionalId: string
  ): Promise<boolean> => {
    if (!establishmentId || deletionInProgress.current) {
      return false
    }

    deletionInProgress.current = true
    setDeletionState('loading')

    try {
      const response = await deleteEstablishmentProfessionalRelation(
        professionalId,
        establishmentId
      )

      if (!response.success) {
        setDeletionState('error')
        return false
      }

      await fetchProfessionals()
      setDeletionState('success')
      return true
    } catch {
      setDeletionState('error')
      return false
    } finally {
      deletionInProgress.current = false
    }
  }

  const handleEditRole = (user: IUserSession) => {
    const basePath = EDIT_PROFESSIONALS(user.professional_id)

    navigate(basePath.startsWith('/') ? basePath : '/' + basePath, {
      state: user
    })
  }

  useEffect(() => {
    if (state !== 'loading') {
      fetchProfessionals()
    }
  }, [establishmentId])

  return {
    professionals,
    isFilteredByEstablishment: !!establishmentId,
    state,
    deletionState,
    handleDeleteProfessional,
    handleEditRole
  }
}

export default useProfessional
